import React from 'react';
import DayPicker from 'react-day-picker';

type CabDatePickerContainerProp = {
  selectedDays: undefined | Date;
  onDayClick: any;
  fromMonth: Date;
  numberOfMonths: number;
  initialMonth: Date;
  disabledDays: any;
};
const CabDatePickerContainer2 = React.memo(
  ({
    selectedDays,
    onDayClick,
    fromMonth,
    numberOfMonths,
    initialMonth,
    disabledDays
  }: CabDatePickerContainerProp) => (
    <DayPicker
      selectedDays={selectedDays}
      onDayClick={onDayClick}
      fromMonth={fromMonth}
      numberOfMonths={numberOfMonths}
      initialMonth={initialMonth}
      disabledDays={disabledDays}
    />
  )
);

export default CabDatePickerContainer2;
